import { Section } from '../ui/Section';
import { TestimonialCarousel } from '../ui/TestimonialCarousel';
import { Testimonials, UserType } from '../../lib/social-proof';

interface TestimonialsSectionProps {
    title?: string;
    subtitle?: string;
    userType?: UserType[];
    centered?: boolean;
    background?: 'transparent' | 'default' | 'paper' | 'gradient' | 'dark';
    showLogos?: boolean;
}

export function TestimonialsSection({
    title = "What our users say",
    subtitle = "Real feedback from clinicians, survivors, and caregivers using neumind.",
    userType,
    centered = true,
    background = "transparent",
    showLogos = false,
    excludeNames = []
}: TestimonialsSectionProps & { excludeNames?: string[] }) {

    let displayedTestimonials = Testimonials;

    if (userType && userType.length > 0) {
        displayedTestimonials = displayedTestimonials.filter(t =>
            t.userType && t.userType.some(u => userType.includes(u))
        );
    }

    if (excludeNames.length > 0) {
        displayedTestimonials = displayedTestimonials.filter(t => !excludeNames.includes(t.name));
    }

    // Sort by order if present
    displayedTestimonials.sort((a, b) => (a.order || 999) - (b.order || 999));

    if (displayedTestimonials.length === 0) return null;

    return (
        <Section
            title={title}
            subtitle={subtitle}
            centered={centered}
            variant={background as any}
        >
            <TestimonialCarousel
                testimonials={displayedTestimonials}
                showLogos={showLogos}
            />
        </Section>
    );
}
